module.exports = __webpack_public_path__ + "static/media/logo192.41d526bc.png";